import type ApiRequestConfig from '@interfaces/apiEndpoints.interface';
const isDev = process.env.NODE_ENV === 'development';

const MAIN_API_URL = '/api/v1';

export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

export const BASE_URL = '/service';

const _myPodsWindowUrl = (window as any).REACT_APP_MY_PODS_URL;
export const MY_PODS_URL = (_myPodsWindowUrl && _myPodsWindowUrl.startsWith('http'))
  ? _myPodsWindowUrl
  : (process.env.REACT_APP_MY_PODS_URL || 'https://mypods.com');

export const API_ENDPOINTS: Record<
  string,
  ApiRequestConfig | ((param: number) => ApiRequestConfig)
> = {

  VERIFY_MEMBER: {
    url: () => `${BASE_URL}${MAIN_API_URL}/membership-verification`,
    method: 'POST',
  },
  COSTCO_SUBSCRIBE: {
    url: () => `${BASE_URL}${MAIN_API_URL}/subscribe`,
    method: 'POST',
  },
  GET_COSTCO_DASHBOARD_REQUESTS: {
    url: (query: string) =>
      `${BASE_URL}${MAIN_API_URL}/membership-verification/memberships${query}`,
    method: 'GET',
  },
  GET_COSTCO_DASHBOARD_REQUESTS_SEARCH: {
    url: (query: string) =>
      `${BASE_URL}${MAIN_API_URL}/membership-verification/search${query}`,
    method: 'GET',
  },
  DOWNLOAD_COSTCO_DASHBOARD_REQUEST: {
    url: (query: string) =>
      `${BASE_URL}${MAIN_API_URL}/membership-verification/download${query}`,
    method: 'GET',
  },
  GET_SYSTEM_PREFERENCES: {
    url: () =>
      `${BASE_URL}${MAIN_API_URL}/membership-verification/preferences`,
    method: 'GET',
  },
  POST_SYSTEM_PREFERENCES: {
    url: () =>
      `${BASE_URL}${MAIN_API_URL}/membership-verification/preferences`,
    method: 'PATCH',
  },
  GET_COSTCO_ANALYTICS: {
    url: (query: string) =>
      `${BASE_URL}${MAIN_API_URL}/membership-verification/analytics${query}`,
    method: 'GET',
  },
  GET_MILITARY_VERIFICATION: {
    url: (verificationId: string) =>
      `${BASE_URL}${MAIN_API_URL}/military/${verificationId}`,
    method: 'GET',
  },
  COMPLETE_MILITARY_VERIFICATION: {
    url: (query: string) => `${BASE_URL}${MAIN_API_URL}/military/complete${query}`,
    method: 'POST',
  },
  REGENERATE_MILITARY_VERIFICATION: {
    url: (verificationId: string) =>
      `${BASE_URL}${MAIN_API_URL}/military/${verificationId}/regenerate`,
    method: 'POST',
  },
  INITIATE_MILITARY_VERIFICATION: {
    url: () => `${BASE_URL}${MAIN_API_URL}/military/initiate`,
    method: 'POST',
  },
  OVERRIDE_MILITARY_VERIFICATION: {
    url: (verificationId: string) =>
      `${BASE_URL}${MAIN_API_URL}/military/${verificationId}/override`,
    method: 'POST',
  },
  RESEND_MILITARY_VERIFICATION: {
    url: (verificationId: string) =>
      `${BASE_URL}${MAIN_API_URL}/military/${verificationId}/resend`,
    method: 'POST',
  },
  REAUTHORIZE_MILITARY: {
    url: (email: string) => `${BASE_URL}${MAIN_API_URL}/military/reauthorize?email=${encodeURIComponent(email)}`,
    method: 'POST',
  },
};
